const EnvironmentTag = () => {
  const isDev = window.location.hostname.includes("dev");
  // const isDev = window.location.hostname.includes("localhost");
  if (!isDev) return null;

  return (
    <div className="fixed top-2 left-0 z-90">
      <div className="relative">
        <div className="absolute left-2  bg-orange-500 text-white text-xs font-bold px-3 py-1 shadow-lg rounded-lg">
          Development
        </div>
      </div>
    </div>
  );
};

export default EnvironmentTag;
